// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/BlackOpsOne-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/BlackOpsOne-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/imgs/dark-ocean-background.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Black Ops One';
  src:
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

:root {
  --system-ui:
    system-ui, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';

  --main-background-color: #222222;
  --main-font-color: #fff;

  --header-background-color-1: #142864;
  --header-background-color-2: #4664a0;
  --logo-font-color: #e5e8eb;
  --logo-text-strike-color: #c7ccce;

  --board-border-color: #fff;
  --square-size: 40px;
  --square-background-color: rgba(90, 115, 140, 0.65);
  --square-ship-background-color: #1f2741;
  --attack-mark-hit-color: #ff5353;
  --attack-mark-miss-color: #ffffff;
  --square-hover-border-color: #f3853c;
  --square-allowed-border-color: #a8e496;
  --square-not-allowed-border-color: #f59191;

  --radar-content-color: #7fff90;
  --radar-background-color: #242b25;
  --radar-border-color: #424242;

  --button-border-color: #c4c4c4;
  --button-background-color: #ebebeb;
  --button-hover-border-color: #b0b6c2;
  --button-hover-background-color: #dde6f1;
}

body {
  min-height: 100vh;
  background-color: var(--main-background-color);
  color: var(--main-font-color);
  font-family: var(--system-ui);
  display: flex;
  flex-direction: column;
  align-items: center;
}

header {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 32px;
  padding: 16px 0px 24px 0px;
  filter: drop-shadow(0 10px 0.75rem rgba(0, 0, 0, 0.25));
  background-color: var(--header-background-color-1);
  background: linear-gradient(
    180deg,
    var(--header-background-color-1) 10%,
    var(--header-background-color-2) 100%
  );

  #logo {
    width: fit-content;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0px;
    filter: drop-shadow(0 0 0.75rem rgba(0, 0, 0, 0.25));

    img {
      width: 280px;
      position: relative;
      top: 4px;
      -webkit-user-drag: none;
      user-select: none;
    }

    #main-title {
      width: fit-content;
      font-family: 'Black Ops One', var(--system-ui);
      font-size: 4.5rem;
      background-color: black;
      border-radius: 16px;
      padding: 4px 16px;
      color: var(--logo-font-color);
      -webkit-text-stroke: 2px var(--logo-text-strike-color);
    }
  }
}

main {
  flex: 1;
  width: 100%;

  .page[hidden='true'] {
    display: none;
  }

  .section[hidden='true'] {
    display: none;
  }
}

#initial-page[hidden='false'] {
  display: flex;
  flex-direction: column;
  align-items: center;

  #subtitle {
    font-size: 1.5rem;
    font-weight: 600;
  }

  #description {
    width: 70ch;
    margin: 16px 0 32px 0;
  }

  .start-game-btn {
    width: 100%;
    display: flex;
    gap: 16px;
    padding: 8px 16px;
    border: none;
    border-radius: 8px;
    border-bottom: 4px solid var(--button-border-color);
    background-color: var(--button-background-color);

    .text {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      letter-spacing: 0.05rem;
      gap: 6px;

      .play-vs {
        font-size: 1rem;
        line-height: 1rem;
        font-weight: 400;
      }

      .opponent {
        text-transform: uppercase;
        font-size: 1.4rem;
        line-height: 1.4rem;
        font-weight: 600;
      }
    }

    .icon {
      width: 40px;
    }

    &:hover {
      background-color: var(--button-hover-background-color);
      border-bottom-color: var(--button-hover-border-color);
      cursor: pointer;
    }
  }

  #players-form {
    display: flex;
    flex-direction: column;
    gap: 32px;

    .wrapper {
      display: flex;
      flex-direction: column;
      gap: 8px;
      font-size: 1.1rem;
    }

    input {
      border-radius: 4px;
      border: none;
      padding: 4px 8px;
    }
  }

  .gamemodes {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;

    #two-player-mode + div {
      text-align: center;
      text-transform: uppercase;
      font-weight: 600;
    }

    .gamemode {
      border: 2px solid #fff;
      padding: 32px 64px;
      display: flex;
      align-items: center;
      border-radius: 8px;
    }
  }
}

#gameplay-page[hidden='false'] {
  flex: 1;
  width: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;

  #feedback-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 8px;
    width: 700px;
    min-height: 80px;
    padding: 16px;
    color: var(--radar-content-color);
    background-color: var(--radar-background-color);
    border: 6px solid var(--radar-border-color);
    border-radius: 32px;
    font-family: 'Black Ops One', monospace, var(--system-ui);
    font-family: 'Courier New', Courier, monospace;
    font-weight: 600;
    font-size: 1.1rem;

    .message {
      display: flex;
      flex-direction: column;
      gap: 4px;
    }
  }

  #players-section {
    width: inherit;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    gap: 16px;
  }

  #new-game-section[hidden='false'] {
    margin: 40px 0;
    display: flex;
    gap: 48px;

    [type='button'] {
      text-transform: uppercase;
      width: 18ch;
      padding: 8px 4px;
      border: none;
      border-radius: 8px;
      border-bottom: 4px solid var(--button-border-color);
      background-color: var(--button-background-color);
      font-weight: 500;

      &:hover {
        background-color: var(--button-hover-background-color);
        border-bottom-color: var(--button-hover-border-color);
        cursor: pointer;
      }
    }
  }
}

#coordinates-info-box {
  margin-left: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 260px;
  min-width: 260px;
  padding: 16px 24px;
  border: 6px solid var(--radar-border-color);
  background-color: var(--radar-background-color);
  border-radius: 32px;
  gap: 8px;

  .title,
  .title + div {
    font-family: 'Courier New', Courier, monospace;
    color: var(--radar-content-color);
    font-weight: 600;
    text-transform: uppercase;
    padding: 4px 8px;
    width: 100%;
    text-align: center;
    font-size: 0.9rem;
  }

  .title {
    border: 2px solid var(--radar-content-color);
  }

  .wrapper {
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: center;
  }

  .missile-box {
    width: 100px;
    user-select: none;
    padding: 16px;

    .icon {
      -webkit-user-drag: none;
    }

    .icon[face-to='left'] {
      transform: rotate(335deg);
    }

    .icon[face-to='right'] {
      transform: rotate(115deg);
    }
  }

  .coordinates {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 1.2rem;
    width: 70px;
    height: 70px;
    padding: 16px;
    font-family: monospace, var(--system-ui);
    font-weight: 600;
    color: var(--radar-content-color);
    border: 3px dashed currentColor;
    border-radius: 16px;
  }
}

.player-box {
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-align: center;
    margin: 16px 0;
    font-size: 1.2rem;
    font-weight: 600;

    .target {
      width: 30px;
      height: 30px;
      margin: 0;

      img.hidden {
        display: none;
      }
    }
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(11, var(--square-size));
    grid-template-rows: repeat(11, var(--square-size));

    & > * {
      align-items: center;
      justify-items: center;
    }
  }

  .indexes {
    display: grid;
    font-weight: 600;

    &.x-indexes {
      grid-template-columns: subgrid;
      grid-column: 2 / -1;
      grid-row: 1 / span 1;
    }

    &.y-indexes {
      grid-template-rows: subgrid;
      grid-column: 1 / span 1;
      grid-row: 2 / -1;
    }
  }

  .board {
    display: grid;
    grid-column: 2 / -1;
    grid-row: 2 / -1;
    grid-template-columns: subgrid;
    grid-template-rows: subgrid;
    outline: 6px solid var(--board-border-color);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: cover;

    .square {
      border: 1px solid var(--board-border-color);
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .attack-mark {
        width: 50%;
        height: 50%;
        border-radius: 50%;
        background-color: transparent;
      }
    }

    .square[ship='false'] {
      background-color: var(--square-background-color);
    }

    .square[ship='true'] {
      background-color: var(--square-ship-background-color);
    }
  }

  .board.on-ship-placement {
    .square[preview='allowed'] {
      border: 4px solid var(--square-allowed-border-color);
      cursor: pointer;
    }

    .square[preview='not-allowed'] {
      border: 4px solid var(--square-not-allowed-border-color);
      cursor: not-allowed;
    }
  }

  .board.on-play {
    .attack-mark {
      transition: background-color 0.5s ease;
    }

    .square[ship='false'][attacked='true'] .attack-mark {
      background-color: var(--attack-mark-miss-color);
    }

    .square[ship='true'][attacked='true'] .attack-mark {
      background-color: var(--attack-mark-hit-color);
    }

    &.hidden-fleet {
      .square[ship='true'] {
        background-color: var(--square-background-color);
      }
    }

    &.targetable {
      .square:hover {
        border: 2px solid var(--square-hover-border-color);
        outline: 2px solid var(--square-hover-border-color);
        z-index: 1;
      }

      .square[attacked='false'] {
        cursor: crosshair;
      }

      .square[attacked='true'] {
        cursor: not-allowed;
      }
    }

    &:not(.targetable) {
      opacity: 60%;

      .square {
        cursor: not-allowed;
      }
    }
  }
}

button.confirm-fleet {
  margin: 30px 0px 20px 40px;
  text-transform: uppercase;
  padding: 8px 32px;
  border: none;
  border-radius: 8px;
  border-bottom: 4px solid var(--button-border-color);
  background-color: var(--button-background-color);
  font-weight: 500;
  font-size: 1rem;

  &:hover {
    background-color: var(--button-hover-background-color);
    border-bottom-color: var(--button-hover-border-color);
    cursor: pointer;
  }
}

span.shift-key {
  border: 1px solid currentColor;
  border-radius: 2px;
  padding: 2px 4px;
  font-size: 0.9em;
}

footer {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 0;
  margin: 20px 0 4px 0;
  width: 100%;

  a {
    text-decoration: none;
    color: inherit;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B;;0DAEgE;EAChE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;;2DAEyD;;EAEzD,gCAAgC;EAChC,uBAAuB;;EAEvB,oCAAoC;EACpC,oCAAoC;EACpC,0BAA0B;EAC1B,iCAAiC;;EAEjC,0BAA0B;EAC1B,mBAAmB;EACnB,mDAAmD;EACnD,uCAAuC;EACvC,gCAAgC;EAChC,iCAAiC;EACjC,oCAAoC;EACpC,sCAAsC;EACtC,0CAA0C;;EAE1C,8BAA8B;EAC9B,iCAAiC;EACjC,6BAA6B;;EAE7B,8BAA8B;EAC9B,kCAAkC;EAClC,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,8CAA8C;EAC9C,6BAA6B;EAC7B,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,0BAA0B;EAC1B,uDAAuD;EACvD,kDAAkD;EAClD;;;;GAIC;;EAED;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,oDAAoD;;IAEpD;MACE,YAAY;MACZ,kBAAkB;MAClB,QAAQ;MACR,uBAAuB;MACvB,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,8CAA8C;MAC9C,iBAAiB;MACjB,uBAAuB;MACvB,mBAAmB;MACnB,iBAAiB;MACjB,6BAA6B;MAC7B,sDAAsD;IACxD;EACF;AACF;;AAEA;EACE,OAAO;EACP,WAAW;;EAEX;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,mDAAmD;IACnD,gDAAgD;;IAEhD;MACE,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,uBAAuB;MACvB,QAAQ;;MAER;QACE,eAAe;QACf,iBAAiB;QACjB,gBAAgB;MAClB;;MAEA;QACE,yBAAyB;QACzB,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB;MAClB;IACF;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,sDAAsD;MACtD,qDAAqD;MACrD,eAAe;IACjB;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;;IAET;MACE,aAAa;MACb,sBAAsB;MACtB,QAAQ;MACR,iBAAiB;IACnB;;IAEA;MACE,kBAAkB;MAClB,YAAY;MACZ,gBAAgB;IAClB;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;;IAER;MACE,kBAAkB;MAClB,yBAAyB;MACzB,gBAAgB;IAClB;;IAEA;MACE,sBAAsB;MACtB,kBAAkB;MAClB,aAAa;MACb,mBAAmB;MACnB,kBAAkB;IACpB;EACF;AACF;;AAEA;EACE,OAAO;EACP,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,iCAAiC;IACjC,+CAA+C;IAC/C,2CAA2C;IAC3C,mBAAmB;IACnB,yDAAyD;IACzD,8CAA8C;IAC9C,gBAAgB;IAChB,iBAAiB;;IAEjB;MACE,aAAa;MACb,sBAAsB;MACtB,QAAQ;IACV;EACF;;EAEA;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,cAAc;IACd,aAAa;IACb,SAAS;;IAET;MACE,yBAAyB;MACzB,WAAW;MACX,gBAAgB;MAChB,YAAY;MACZ,kBAAkB;MAClB,mDAAmD;MACnD,gDAAgD;MAChD,gBAAgB;;MAEhB;QACE,sDAAsD;QACtD,qDAAqD;QACrD,eAAe;MACjB;IACF;EACF;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,+CAA+C;EAC/C,mBAAmB;EACnB,QAAQ;;EAER;;IAEE,8CAA8C;IAC9C,iCAAiC;IACjC,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,4CAA4C;EAC9C;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,aAAa;;IAEb;MACE,uBAAuB;IACzB;;IAEA;MACE,yBAAyB;IAC3B;;IAEA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,wCAAwC;IACxC,gBAAgB;IAChB,iCAAiC;IACjC,+BAA+B;IAC/B,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;;EAEvB;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;;IAEhB;MACE,WAAW;MACX,YAAY;MACZ,SAAS;;MAET;QACE,aAAa;MACf;IACF;EACF;;EAEA;IACE,aAAa;IACb,qDAAqD;IACrD,kDAAkD;;IAElD;MACE,mBAAmB;MACnB,qBAAqB;IACvB;EACF;;EAEA;IACE,aAAa;IACb,gBAAgB;;IAEhB;MACE,8BAA8B;MAC9B,mBAAmB;MACnB,oBAAoB;IACtB;;IAEA;MACE,2BAA2B;MAC3B,uBAAuB;MACvB,gBAAgB;IAClB;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,8BAA8B;IAC9B,2BAA2B;IAC3B,4CAA4C;IAC5C,yDAAiE;IACjE,sBAAsB;;IAEtB;MACE,2CAA2C;MAC3C,WAAW;MACX,YAAY;MACZ,aAAa;MACb,mBAAmB;MACnB,uBAAuB;;MAEvB;QACE,UAAU;QACV,WAAW;QACX,kBAAkB;QAClB,6BAA6B;MAC/B;IACF;;IAEA;MACE,gDAAgD;IAClD;;IAEA;MACE,qDAAqD;IACvD;EACF;;EAEA;IACE;MACE,oDAAoD;MACpD,eAAe;IACjB;;IAEA;MACE,wDAAwD;MACxD,mBAAmB;IACrB;EACF;;EAEA;IACE;MACE,sCAAsC;IACxC;;IAEA;MACE,+CAA+C;IACjD;;IAEA;MACE,8CAA8C;IAChD;;IAEA;MACE;QACE,gDAAgD;MAClD;IACF;;IAEA;MACE;QACE,kDAAkD;QAClD,mDAAmD;QACnD,UAAU;MACZ;;MAEA;QACE,iBAAiB;MACnB;;MAEA;QACE,mBAAmB;MACrB;IACF;;IAEA;MACE,YAAY;;MAEZ;QACE,mBAAmB;MACrB;IACF;EACF;AACF;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,mDAAmD;EACnD,gDAAgD;EAChD,gBAAgB;EAChB,eAAe;;EAEf;IACE,sDAAsD;IACtD,qDAAqD;IACrD,eAAe;EACjB;AACF;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,WAAW;;EAEX;IACE,qBAAqB;IACrB,cAAc;EAChB;AACF","sourcesContent":["@font-face {\n  font-family: 'Black Ops One';\n  src:\n    url('../assets/fonts/BlackOpsOne-Regular.woff2') format('woff2'),\n    url('../assets/fonts/BlackOpsOne-Regular.woff') format('woff');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n:root {\n  --system-ui:\n    system-ui, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji',\n    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';\n\n  --main-background-color: #222222;\n  --main-font-color: #fff;\n\n  --header-background-color-1: #142864;\n  --header-background-color-2: #4664a0;\n  --logo-font-color: #e5e8eb;\n  --logo-text-strike-color: #c7ccce;\n\n  --board-border-color: #fff;\n  --square-size: 40px;\n  --square-background-color: rgba(90, 115, 140, 0.65);\n  --square-ship-background-color: #1f2741;\n  --attack-mark-hit-color: #ff5353;\n  --attack-mark-miss-color: #ffffff;\n  --square-hover-border-color: #f3853c;\n  --square-allowed-border-color: #a8e496;\n  --square-not-allowed-border-color: #f59191;\n\n  --radar-content-color: #7fff90;\n  --radar-background-color: #242b25;\n  --radar-border-color: #424242;\n\n  --button-border-color: #c4c4c4;\n  --button-background-color: #ebebeb;\n  --button-hover-border-color: #b0b6c2;\n  --button-hover-background-color: #dde6f1;\n}\n\nbody {\n  min-height: 100vh;\n  background-color: var(--main-background-color);\n  color: var(--main-font-color);\n  font-family: var(--system-ui);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\nheader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-bottom: 32px;\n  padding: 16px 0px 24px 0px;\n  filter: drop-shadow(0 10px 0.75rem rgba(0, 0, 0, 0.25));\n  background-color: var(--header-background-color-1);\n  background: linear-gradient(\n    180deg,\n    var(--header-background-color-1) 10%,\n    var(--header-background-color-2) 100%\n  );\n\n  #logo {\n    width: fit-content;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0px;\n    filter: drop-shadow(0 0 0.75rem rgba(0, 0, 0, 0.25));\n\n    img {\n      width: 280px;\n      position: relative;\n      top: 4px;\n      -webkit-user-drag: none;\n      user-select: none;\n    }\n\n    #main-title {\n      width: fit-content;\n      font-family: 'Black Ops One', var(--system-ui);\n      font-size: 4.5rem;\n      background-color: black;\n      border-radius: 16px;\n      padding: 4px 16px;\n      color: var(--logo-font-color);\n      -webkit-text-stroke: 2px var(--logo-text-strike-color);\n    }\n  }\n}\n\nmain {\n  flex: 1;\n  width: 100%;\n\n  .page[hidden='true'] {\n    display: none;\n  }\n\n  .section[hidden='true'] {\n    display: none;\n  }\n}\n\n#initial-page[hidden='false'] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  #subtitle {\n    font-size: 1.5rem;\n    font-weight: 600;\n  }\n\n  #description {\n    width: 70ch;\n    margin: 16px 0 32px 0;\n  }\n\n  .start-game-btn {\n    width: 100%;\n    display: flex;\n    gap: 16px;\n    padding: 8px 16px;\n    border: none;\n    border-radius: 8px;\n    border-bottom: 4px solid var(--button-border-color);\n    background-color: var(--button-background-color);\n\n    .text {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n      letter-spacing: 0.05rem;\n      gap: 6px;\n\n      .play-vs {\n        font-size: 1rem;\n        line-height: 1rem;\n        font-weight: 400;\n      }\n\n      .opponent {\n        text-transform: uppercase;\n        font-size: 1.4rem;\n        line-height: 1.4rem;\n        font-weight: 600;\n      }\n    }\n\n    .icon {\n      width: 40px;\n    }\n\n    &:hover {\n      background-color: var(--button-hover-background-color);\n      border-bottom-color: var(--button-hover-border-color);\n      cursor: pointer;\n    }\n  }\n\n  #players-form {\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n\n    .wrapper {\n      display: flex;\n      flex-direction: column;\n      gap: 8px;\n      font-size: 1.1rem;\n    }\n\n    input {\n      border-radius: 4px;\n      border: none;\n      padding: 4px 8px;\n    }\n  }\n\n  .gamemodes {\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    gap: 8px;\n\n    #two-player-mode + div {\n      text-align: center;\n      text-transform: uppercase;\n      font-weight: 600;\n    }\n\n    .gamemode {\n      border: 2px solid #fff;\n      padding: 32px 64px;\n      display: flex;\n      align-items: center;\n      border-radius: 8px;\n    }\n  }\n}\n\n#gameplay-page[hidden='false'] {\n  flex: 1;\n  width: inherit;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  #feedback-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    gap: 8px;\n    width: 700px;\n    min-height: 80px;\n    padding: 16px;\n    color: var(--radar-content-color);\n    background-color: var(--radar-background-color);\n    border: 6px solid var(--radar-border-color);\n    border-radius: 32px;\n    font-family: 'Black Ops One', monospace, var(--system-ui);\n    font-family: 'Courier New', Courier, monospace;\n    font-weight: 600;\n    font-size: 1.1rem;\n\n    .message {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n    }\n  }\n\n  #players-section {\n    width: inherit;\n    display: flex;\n    align-items: center;\n    flex-direction: row;\n    justify-content: center;\n    gap: 16px;\n  }\n\n  #new-game-section[hidden='false'] {\n    margin: 40px 0;\n    display: flex;\n    gap: 48px;\n\n    [type='button'] {\n      text-transform: uppercase;\n      width: 18ch;\n      padding: 8px 4px;\n      border: none;\n      border-radius: 8px;\n      border-bottom: 4px solid var(--button-border-color);\n      background-color: var(--button-background-color);\n      font-weight: 500;\n\n      &:hover {\n        background-color: var(--button-hover-background-color);\n        border-bottom-color: var(--button-hover-border-color);\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n#coordinates-info-box {\n  margin-left: 40px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 260px;\n  min-width: 260px;\n  padding: 16px 24px;\n  border: 6px solid var(--radar-border-color);\n  background-color: var(--radar-background-color);\n  border-radius: 32px;\n  gap: 8px;\n\n  .title,\n  .title + div {\n    font-family: 'Courier New', Courier, monospace;\n    color: var(--radar-content-color);\n    font-weight: 600;\n    text-transform: uppercase;\n    padding: 4px 8px;\n    width: 100%;\n    text-align: center;\n    font-size: 0.9rem;\n  }\n\n  .title {\n    border: 2px solid var(--radar-content-color);\n  }\n\n  .wrapper {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .missile-box {\n    width: 100px;\n    user-select: none;\n    padding: 16px;\n\n    .icon {\n      -webkit-user-drag: none;\n    }\n\n    .icon[face-to='left'] {\n      transform: rotate(335deg);\n    }\n\n    .icon[face-to='right'] {\n      transform: rotate(115deg);\n    }\n  }\n\n  .coordinates {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    font-size: 1.2rem;\n    width: 70px;\n    height: 70px;\n    padding: 16px;\n    font-family: monospace, var(--system-ui);\n    font-weight: 600;\n    color: var(--radar-content-color);\n    border: 3px dashed currentColor;\n    border-radius: 16px;\n  }\n}\n\n.player-box {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  .title {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    text-align: center;\n    margin: 16px 0;\n    font-size: 1.2rem;\n    font-weight: 600;\n\n    .target {\n      width: 30px;\n      height: 30px;\n      margin: 0;\n\n      img.hidden {\n        display: none;\n      }\n    }\n  }\n\n  .grid {\n    display: grid;\n    grid-template-columns: repeat(11, var(--square-size));\n    grid-template-rows: repeat(11, var(--square-size));\n\n    & > * {\n      align-items: center;\n      justify-items: center;\n    }\n  }\n\n  .indexes {\n    display: grid;\n    font-weight: 600;\n\n    &.x-indexes {\n      grid-template-columns: subgrid;\n      grid-column: 2 / -1;\n      grid-row: 1 / span 1;\n    }\n\n    &.y-indexes {\n      grid-template-rows: subgrid;\n      grid-column: 1 / span 1;\n      grid-row: 2 / -1;\n    }\n  }\n\n  .board {\n    display: grid;\n    grid-column: 2 / -1;\n    grid-row: 2 / -1;\n    grid-template-columns: subgrid;\n    grid-template-rows: subgrid;\n    outline: 6px solid var(--board-border-color);\n    background-image: url('../assets/imgs/dark-ocean-background.png');\n    background-size: cover;\n\n    .square {\n      border: 1px solid var(--board-border-color);\n      width: 100%;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      .attack-mark {\n        width: 50%;\n        height: 50%;\n        border-radius: 50%;\n        background-color: transparent;\n      }\n    }\n\n    .square[ship='false'] {\n      background-color: var(--square-background-color);\n    }\n\n    .square[ship='true'] {\n      background-color: var(--square-ship-background-color);\n    }\n  }\n\n  .board.on-ship-placement {\n    .square[preview='allowed'] {\n      border: 4px solid var(--square-allowed-border-color);\n      cursor: pointer;\n    }\n\n    .square[preview='not-allowed'] {\n      border: 4px solid var(--square-not-allowed-border-color);\n      cursor: not-allowed;\n    }\n  }\n\n  .board.on-play {\n    .attack-mark {\n      transition: background-color 0.5s ease;\n    }\n\n    .square[ship='false'][attacked='true'] .attack-mark {\n      background-color: var(--attack-mark-miss-color);\n    }\n\n    .square[ship='true'][attacked='true'] .attack-mark {\n      background-color: var(--attack-mark-hit-color);\n    }\n\n    &.hidden-fleet {\n      .square[ship='true'] {\n        background-color: var(--square-background-color);\n      }\n    }\n\n    &.targetable {\n      .square:hover {\n        border: 2px solid var(--square-hover-border-color);\n        outline: 2px solid var(--square-hover-border-color);\n        z-index: 1;\n      }\n\n      .square[attacked='false'] {\n        cursor: crosshair;\n      }\n\n      .square[attacked='true'] {\n        cursor: not-allowed;\n      }\n    }\n\n    &:not(.targetable) {\n      opacity: 60%;\n\n      .square {\n        cursor: not-allowed;\n      }\n    }\n  }\n}\n\nbutton.confirm-fleet {\n  margin: 30px 0px 20px 40px;\n  text-transform: uppercase;\n  padding: 8px 32px;\n  border: none;\n  border-radius: 8px;\n  border-bottom: 4px solid var(--button-border-color);\n  background-color: var(--button-background-color);\n  font-weight: 500;\n  font-size: 1rem;\n\n  &:hover {\n    background-color: var(--button-hover-background-color);\n    border-bottom-color: var(--button-hover-border-color);\n    cursor: pointer;\n  }\n}\n\nspan.shift-key {\n  border: 1px solid currentColor;\n  border-radius: 2px;\n  padding: 2px 4px;\n  font-size: 0.9em;\n}\n\nfooter {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 2px 0;\n  margin: 20px 0 4px 0;\n  width: 100%;\n\n  a {\n    text-decoration: none;\n    color: inherit;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
